import financeCollection from './financecollection'

export default {financeCollection}